import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import {
  transactionFields,
  transactionEecsGOInfoFields,
} from '../../constants/transaction';

export const TransactionEecsGODetails = ({ info, t }) => {
  const eecsGoInfo = info?.[transactionFields.GO_INFORMATION] || {};

  return (
    <React.Fragment>
      <Row className="global-margin-bottom-10">
        <Col span={8}>
          <b>{t('go.amount')}: </b>
          {eecsGoInfo?.[transactionEecsGOInfoFields.GO_AMOUNT]}
        </Col>
        <Col span={8}>
          <b>{t('go.productionPeriod')}: </b>
          {eecsGoInfo?.[transactionEecsGOInfoFields.PRODUCTION_PERIOD]}
        </Col>
        <Col span={8}>
          <b>{t('go.unitEecsCode')}: </b>
          {eecsGoInfo?.[transactionEecsGOInfoFields.UNIT_EECS_CODE]}
        </Col>
      </Row>
      <Row className="global-margin-bottom-10">
        <Col span={8}>
          <b>{t('go.productionTechnology')}: </b>
          {eecsGoInfo?.[transactionEecsGOInfoFields.PRODUCTION_TECHNOLOGY]}
        </Col>
        <Col span={8}>
          <b>{t('go.feedstock')}: </b>
          {eecsGoInfo?.[transactionEecsGOInfoFields.FEEDSTOCK]}
        </Col>
      </Row>
      <Row className="global-margin-bottom-10" />
    </React.Fragment>
  );
};

TransactionEecsGODetails.propTypes = {
  info: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};
